import React, { useEffect, useState } from 'react'
import CustomTable from '../../customControl/CustomTable';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { loaderActions } from '../../_actions/loader.actions';
import { getAllData, verifytoken } from '../../services/ApiCallingUserServices';
import { ClearLocalStorage } from '../../components/commonClass/Session';
import CommonFilter from '../../customControl/CommonFilter';
import { userrights } from '../../components/commonClass/CommonInterfaceTypes';

const TravelerProfileList = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [datalist, setDataList] = useState<any>([]);
    const [filterlist, setFilterList] = useState<any>([]);
    const [searchby, setSerachBy] = useState('All');
    const [searchvalue, setSearchValue] = useState('');
    const user = useSelector((store: any) => store.userstatus.tba);
    const menuItem = useSelector((store: any) => store.menuitems.menu);
    const [userRights, setUserRights] = useState<userrights>();

    const gettravelerprofilelist = async () => {
        let statusoftoken = await verifytoken();
        if (statusoftoken) {
            dispatch(loaderActions.start());
            const travelerprofilelist = await getAllData('/midoffice/v1/gettravelerprofilelist');

            setDataList(travelerprofilelist?.data);
            setFilterList(travelerprofilelist?.data)
            dispatch(loaderActions.end());
        }
        else {
            dispatch(loaderActions.end());
            ClearLocalStorage();
            dispatch({ type: 'SESSIONOUT', message: 'Your Session Expired. Please Login Again!' })
        }
    }
    const columns: any = [
        {
            name: 'Sr. No.',
            sortable: true,
            float: "left",
            isSearch: false,
            isExport: true,
            selector: (listData: any, index: number) => index + 1,
            omit: false
        },
        {
            name: 'Traveler ID',
            sortable: true,
            float: "left",
            isSearch: true,
            isExport: true,
            // selector: (listData: any) => listData.fullName,
            omit: true
        },
        {
            name: 'Name',
            key: 'UserName',
            sortable: true,
            float: "left",
            isSearch: true,
            isExport: true,
            selector: (listData: any) => listData?.UserName,
        },
        {
            name: 'Gender',
            sortable: true,
            float: "left",
            isSearch: true,
            isExport: true,
            selector: (listData: any) => listData?.Gender,
            omit: true
        },
        {
            name: 'Email',
            key: 'UserEmail',
            sortable: true,
            float: "left",
            isSearch: true,
            isExport: true,
            selector: (listData: any) => listData?.UserEmail,
        },
        {
            name: 'Mobile No.',
            key: 'ContactNo',
            sortable: true,
            float: "left",
            isSearch: true,
            isExport: true,
            selector: (listData: any) => listData?.ContactNo,
        },
        {
            name: 'Source',
            key: 'IsOnlineLabel',
            sortable: true,
            float: "left",
            isSearch: true,
            isExport: true,
            selector: (listData: any) => listData?.IsOnlineLabel,
        },
        {
            name: 'Booking ID',
            sortable: true,
            float: "left",
            isSearch: false,
            isExport: false,
            // selector: (listData: any) => listData.userEmail,
            omit: true
        },
        {
            name: 'Agent Name',
            sortable: true,
            float: "left",
            isSearch: false,
            isExport: false,
            // selector: (listData: any) => listData.contactNo,
            omit: true
        },
        {
            name: 'Booking Status',
            sortable: true,
            float: "left",
            isSearch: false,
            isExport: false,
            // selector: (listData: any) => listData.IsActive
            omit: true
        },
        {
            name: 'Payment Status',
            sortable: true,
            float: "left",
            isSearch: false,
            isExport: false,
            // selector: (listData: any) => listData.IsActive
            omit: true
        },
        {
            name: 'Traveller City',
            key: 'City',
            sortable: true,
            float: "left",
            isSearch: true,
            isExport: true,
            selector: (listData: any) => listData?.City
        },
        {
            name: 'Edit',
            selector: (listData: any) => <button type='button' className='border-0 p-0 bg-transparent set_disableclr' disabled={!userRights?.URightEdit}><i className="fa-regular fa-pen-to-square" onClick={() => handleEdit(listData.UserMasterID)}></i></button>
        },
        {
            name: 'View',
            selector: (listData: any) => <button type='button' className='border-0 p-0 bg-transparent set_disableclr'><i className="fa-regular fa-eye" onClick={() => handleView(listData.UserMasterID)}></i></button>
        }
    ];

    useEffect(() => {
        gettravelerprofilelist();
    }, [])

    //#region handle rights
    useEffect(() => {
        //check for rights
        if (user) {
            const pathname = window?.location?.pathname?.toLowerCase();
            const hasRights: userrights = user?.find((fil: any) => fil?.PageLink?.toLowerCase() === pathname)
            setUserRights(hasRights)
            if (!hasRights?.URightView) {
                navigate('/dashboard');
            }
        }
    }, [user]);
    //#endregion

    const handleOpen = () => {
        navigate('/createtravelerprofile');
    }
    const handleEdit = (id: any) => {
        navigate('/createtravelerprofile', { state: { disabled: false, editdisabled: true, viewtype: 'Update', Id: id } });
    }
    const handleView = (id: any) => {
        navigate('/createtravelerprofile', { state: { disabled: true, editdisabled: true, viewtype: 'View', Id: id } });
    }

    return (
        <>
            <div className="mx-2 mt-0 mb-3 heading_color">
                <h2 className='fw-bold'>{menuItem?.[1]?.pageTitle}</h2>
            </div>
            <div className="m-2 heading_color">
                <h4>{menuItem?.[2]?.pageTitle}</h4>
            </div>
            <div className="m-2">
                <form action="" className='mt-3'>
                    <div className="d-flex justify-content-start">
                        <button type="button" disabled={!userRights?.URightAdd} className="btn btn-primary" id="btnAdd" onClick={handleOpen} >+ Create Traveler</button>
                    </div>

                    <CommonFilter
                        filtercolumns={columns}
                        filteritems={filterlist}
                        setFilterList={setDataList}
                        getdata={gettravelerprofilelist}
                        // serchdisable={serchdisable}
                        setSearchValue={setSearchValue}
                        searchvalue={searchvalue}
                        setSerachBy={setSerachBy}
                        searchby={searchby}
                    />

                    <CustomTable
                        className={"last_two_column_freeze"}
                        columns={columns}
                        data={datalist}
                        PdfExport={false}
                        ExportToExcel={false}
                        disabled={!userRights?.URightExport}
                    />
                </form>
            </div >
        </>
    )
}

export default TravelerProfileList